var cilBluetooth = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M150.627,376,232,294.627V496h38.627l120-120-120-120,120-120-120-120H232V217.373L150.627,136H105.373l120,120-120,120ZM264,54.627,345.373,136,264,217.373Zm0,240L345.373,376,264,457.373Z' class='ci-primary'/>"];

export { cilBluetooth };

